import { render, staticRenderFns } from "./activityReferenceAcademicDetails.html?vue&type=template&id=40dd73ef&scoped=true&external"
import script from "./activityReferenceAcademicDetails.vue?vue&type=script&lang=js"
export * from "./activityReferenceAcademicDetails.vue?vue&type=script&lang=js"
import style0 from "./activityReferenceAcademicDetails.css?vue&type=style&index=0&id=40dd73ef&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dd73ef",
  null
  
)

export default component.exports